import React, { ReactNode } from "react";
import { DataTypeEnum, FormTypeEnum } from "@/services/entity.service";
import {
  Type,
  Hash,
  Calendar,
  ToggleLeft,
  FileText,
  Link as LinkIcon,
  Mail,
  Phone,
  Link,
  DollarSign,
  Euro,
} from "lucide-react";

export const getFieldIcon = (iconType: DataTypeEnum | FormTypeEnum | "relation"): ReactNode => {
  switch (iconType) {
    case "TEXT":
    case "LONGTEXT":
    case "RICHTEXT":
      return <Type className="h-4 w-4" />;
    case "INT":
    case "FLOAT":
      return <Hash className="h-4 w-4" />;
    case "DATE":
    case "DATETIME":
    case "TIME":
      return <Calendar className="h-4 w-4" />;
    case "BOOLEAN":
      return <ToggleLeft className="h-4 w-4" />;
    case "JSON":
    case "OBJECT":
      return <FileText className="h-4 w-4" />;
    case "EMAIL":
      return <Mail className="h-4 w-4" />;
    case "PHONE":
      return <Phone className="h-4 w-4" />;
    case "WEBSITE":
      return <Link className="h-4 w-4" />;
    case "CURRENCY":
      return <Euro className="h-4 w-4" />;
    case "PERCENT":
      return <Type className="h-4 w-4" />;
    case "relation":
      return <LinkIcon className="h-4 w-4" />;
    default:
      return <Type className="h-4 w-4" />;
  }
};

export const getColumnSpanClass = (width: number): string => {
  switch (width) {
    case 1:
      return "col-span-1";
    case 2:
      return "col-span-2";
    case 3:
      return "col-span-3";
    default:
      return "col-span-1";
  }
};

export const getRowSpanClass = (height: number): string => {
  switch (height) {
    case 1:
      return "row-span-1";
    case 2:
      return "row-span-2";
    case 3:
      return "row-span-3";
    default:
      return "row-span-1";
  }
};
